class Values
{
    static INV_DATE = 'Invalid Date' 

}
export default Values;